import styled, {keyframes} from 'styled-components';

const ROW_COUNT = 6;

const shimmer = keyframes`
	0% { background-position: -200% 0; }
	100% { background-position: 200% 0; }
`;

const Shimmer = styled.div`
	background: linear-gradient(90deg, #e2e8f0 25%, #f1f5f9 50%, #e2e8f0 75%);
	background-size: 200% 100%;
	animation: ${shimmer} 1.5s infinite ease-in-out;
`;
const Row = styled.div`
	display: grid;
	grid-template-columns: 5rem 80px minmax(200px, 2fr) 140px 120px 100px 130px;
	align-items: center;
	gap: 12px;
	padding-left: 16px;
	padding-right: 16px;
`;
const HeaderRow = styled(Row)`
	border-bottom: 1px solid #e2e8f0;
	padding-top: 8px;
	padding-bottom: 8px;
`;
const BodyRow = styled(Row)`
	border-bottom: 1px solid #f1f5f9;
	padding-top: 12px;
	padding-bottom: 12px;
`;
const Bar = styled(Shimmer)<{$w?: string; $h?: string; $round?: boolean}>`
	height: ${p => p.$h ?? '12px'};
	width: ${p => p.$w ?? 'auto'};
	border-radius: ${p => (p.$round ? '9999px' : '4px')};
`;

export function TicketListSkeleton() {
	return (
		<div aria-label="Loading tickets" aria-busy="true" role="status">
			<HeaderRow>
				<Bar $w="40px" />
				<Bar $w="56px" />
				<Bar $w="80px" />
				<Bar $w="64px" />
				<Bar $w="56px" />
				<Bar $w="48px" />
				<Bar $w="64px" />
			</HeaderRow>
			{Array.from({length: ROW_COUNT}).map((_, i) => (
				<BodyRow key={i} data-testid="skeleton-row">
					<Bar $h="16px" $w="56px" />
					<Bar $h="20px" $w="64px" $round />
					<Bar $h="16px" $w={`${65 + (i % 3) * 10}%`} />
					<Bar $h="16px" $w="80px" />
					<Bar $h="28px" $w="28px" $round />
					<Bar $h="20px" $w="64px" $round />
					<Bar $h="16px" $w="64px" />
				</BodyRow>
			))}
		</div>
	);
}
